module.exports = __webpack_public_path__ + "img/Logo.9c05b6f3.svg";